import { livewire_hot_reload } from "virtual:livewire-hot-reload";
import "./bootstrap";
livewire_hot_reload();

const cmpCallback = (consentData, success) => {
    if (!success) {
        console.error("Failed to retrieve consent data");
        return;
    }
    if (consentData.eventStatus === "cmpuishown") {
        return;
    }

    console.log("called");

    if (
        success &&
        (consentData.eventStatus === "tcloaded" ||
            consentData.eventStatus === "useractioncomplete")
    ) {
        console.log("Consent data retrieved:", consentData);

        // Check if localStorage item exists before proceeding
        if (!window.localStorage.gbc_consent) {
            return;
        }

        let googleConsent = JSON.parse(window.localStorage.gbc_consent);
        let cookiesConsent = googleConsent[0].selected ? "granted" : "denied";
        let adsConsent = googleConsent[1].selected ? "granted" : "denied";
        let personalizationConsent = googleConsent[2].selected
            ? "granted"
            : "denied";
        console.log("Cookies consent:", cookiesConsent);
        console.log("Ads consent:", adsConsent);
        console.log("Personalization consent:", personalizationConsent);

        if (!window.zaraz) {
            console.log("Zaraz not loaded");
            return;
        }
        window.zaraz.set("google_consent_update", {
            ad_storage: adsConsent,
            ad_user_data: adsConsent,
            ad_personalization: personalizationConsent,
            analytics_storage: cookiesConsent,
        });
        console.log("Google consent updated");
    }
};

function waitForTcfApi() {
    if (typeof window.__tcfapi === "function") {
        // __tcfapi is loaded, now we can call it
        window.__tcfapi("addEventListener", 2, cmpCallback);
    } else {
        // __tcfapi is not loaded yet, check again in 100ms
        setTimeout(waitForTcfApi, 100);
    }
}

waitForTcfApi();